module.exports = __webpack_public_path__ + "static/media/cr_1.f463338c.png";